import { UnknownAction } from "redux";
import { isSpecialsAction } from "../actions/Specials.js";
import { Special } from "../types/index.js";

const reducer = (state: Special[] = [], action: UnknownAction): Special[] => {
  if (!isSpecialsAction(action)) {
    return state;
  }

  switch (action.type) {
    case "GET_SPECIALS_SUCCESS":
      return action.specials;

    default:
      return state;
  }
};

export default reducer;
